import React, { Component } from "react";

import { connect } from "react-redux";
import { withRouter } from "react-router-dom";

import SwiperSlider from "./SwiperSlider";
import ProductFeature from "./ProductFeature";
import Marketing from "./Marketing";
import Evaluate from "./Evaluate";
import Header from "../inc/Header";
import BottomToTop from "../inc/BottomToTop";
import OrderNow from "../inc/OrderNow";
import Footer from "../inc/Footer";
import { Helmet } from "react-helmet";
import EvaluateFooter from "./EvaluateFooter";
import seoMeta from "../../../assets/SEO/seoMeta.json";
import SignUpForTrial from "../inc/SignUpForTrial";
const seo = seoMeta.organization;

class Home extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {}
  componentDidUpdate(prevProps, prevState, snapshot) {}

  render() {
    return (
      <>
        <Helmet>
          <title>{seo.title}</title>
          <meta name="description" content={seo.description} />
          <meta name="keywords" content={seo.keywords} />

          {/* OG Tags */}
          <meta property="og:title" content={seo.og.title} />
          <meta property="og:description" content={seo.og.description} />
          <meta property="og:image" content={seo.og.image} />
          <meta property="og:url" content={seo.og.url} />
          <meta property="og:site_name" content={seo.og.site_name} />
          <meta property="og:type" content={seo.og.type} />
          <meta property="og:locale" content={seo.og.locale} />

          <meta name="twitter:card" content={seo.twitter.card} />
          <meta name="twitter:title" content={seo.twitter.title} />
          <meta name="twitter:description" content={seo.twitter.description} />
          <meta name="twitter:image" content={seo.twitter.image} />
          {seo.twitter.site && (
            <meta name="twitter:site" content={seo.twitter.site} />
          )}
          {seo.twitter.creator && (
            <meta name="twitter:creator" content={seo.twitter.creator} />
          )}

          {/* Meta tags khác */}
          <meta name="RATING" content={seo.meta.rating} />
          <meta name="robots" content={seo.meta.robots} />
          <meta name="copyright" content={seo.meta.copyright} />
          <meta name="author" content={seo.meta.author} />
          <meta name="audience" content={seo.meta.audience} />
          <meta name="resource-type" content={seo.meta.resource_type} />
          <meta name="distribution" content={seo.meta.distribution} />
          <meta name="revisit-after" content={seo.meta.revisit_after} />
          <meta name="GENERATOR" content={seo.meta.generator} />

          {/* Link tags */}
          <link rel="canonical" href={seo.canonical} />
          <link rel="alternate" href={seo.hreflang.vi} hreflang="vi" />
          {/* <link rel="shortcut icon" href={seo.favicon} type="image/x-icon" />
          <link rel="apple-touch-icon" href={seo.favicon} />
          <link rel="apple-touch-icon-precomposed" href={seo.favicon} /> */}

          {/* JSON-LD Schema */}
          <script type="application/ld+json">
            {JSON.stringify(seo.jsonld)}
          </script>
        </Helmet>
        <Header />
        <SwiperSlider />
        <EvaluateFooter />
        {/* <HotFeature /> */}
        <Evaluate />
        <ProductFeature />
        <Marketing />
        <Footer />
        <BottomToTop />
        <OrderNow />
        {/* <SignUpForTrial /> */}
      </>
    );
  }
}
const mapStateToProps = (state) => {
  return {};
};

const mapDispatchToProps = (dispatch) => {
  return {};
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Home));
